{
    "serverAdress": "dolimot-server.gracoon.com",
    "port": 5080,
    "mode": "release"
}
